var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wx-page"},[_c('div',{staticClass:"title"},[_vm._v("微信扫码支付")]),_c('div',{ref:"qrcodeBox",staticClass:"qecode-wrapper"}),_c('div',{staticClass:"pay-num-container"},[_c('div',{staticClass:"title"},[_vm._v("应付金额")]),_c('div',{staticClass:"num"},[_vm._v("￥"+_vm._s(_vm.getTotal))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }